module.exports = __webpack_public_path__ + "static/media/realtalk_sd_links162b75d9844761fba3d154dfc633d67e.webp";